/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiResourceType } from './ApiResourceType';
import {
  ApiResourceTypeFromJSON,
  ApiResourceTypeFromJSONTyped,
  ApiResourceTypeToJSON,
  ApiResourceTypeToJSONTyped,
} from './ApiResourceType';

/**
 *
 * @export
 * @interface ApiResourceKey
 */
export interface ApiResourceKey {
  /**
   *
   * @type {ApiResourceType}
   * @memberof ApiResourceKey
   */
  type?: ApiResourceType;
  /**
   * The ID of the resource that referred to.
   * @type {string}
   * @memberof ApiResourceKey
   */
  id?: string;
}

/**
 * Check if a given object implements the ApiResourceKey interface.
 */
export function instanceOfApiResourceKey(value: object): value is ApiResourceKey {
  return true;
}

export function ApiResourceKeyFromJSON(json: any): ApiResourceKey {
  return ApiResourceKeyFromJSONTyped(json, false);
}

export function ApiResourceKeyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiResourceKey {
  if (json == null) {
    return json;
  }
  return {
    type: json['type'] == null ? undefined : ApiResourceTypeFromJSON(json['type']),
    id: json['id'] == null ? undefined : json['id'],
  };
}

export function ApiResourceKeyToJSON(json: any): ApiResourceKey {
  return ApiResourceKeyToJSONTyped(json, false);
}

export function ApiResourceKeyToJSONTyped(
  value?: ApiResourceKey | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    type: ApiResourceTypeToJSON(value['type']),
    id: value['id'],
  };
}
